import { createAction } from '@ngrx/store';

export const sessionEnded = createAction('[Reader] Session Ended');
